module.exports = __webpack_public_path__ + "img/2025-03-18-01-01.0ab5dc0d.png";